import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import {
  MetricSettingsModalComponent,
  MetricSettingsModalResult,
} from '../metric-settings-modal/metric-settings-modal.component';
import { WidgetPredictiveOptions } from '../widget-predictive/widget-predictive.component';
import { MetricSettingsPipe } from './metric-settings.pipe';

@EnableClassTelemetry()
@Component({
  selector: 'app-metric-settings-pill',
  imports: [AppSharedModule, MetricSettingsModalComponent, MetricSettingsPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './metric-settings-pill.component.html',
  styleUrl: './metric-settings-pill.component.scss',
})
export class MetricSettingsPillComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() predictiveOptions!: WidgetPredictiveOptions;
  @Input() isReadOnly!: boolean;
  @Input() isDashboardLocked!: boolean;

  @Output() settingsChange = new EventEmitter<MetricSettingsModalResult>();

  isModalVisible = false;

  onOpenModal(): void {
    this.isModalVisible = true;
  }

  onCloseModal(result: MetricSettingsModalResult | null): void {
    this.isModalVisible = false;

    if (result) {
      this.settingsChange.emit(result);
    }
  }

  get isDisabled(): boolean {
    return this.isReadOnly || this.isDashboardLocked;
  }
}
